// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee from "./buhta_payroll_hrm_v1alpha1_employee.js";
import * as Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data from "./buhta_payroll_hrm_v1alpha1_employment_event_data.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetEmployeeRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1379,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetEmployeeResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1442,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEmployeesRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1502,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListEmployeesResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1562,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateEmployeeRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1622,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateEmployeeResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1682,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateEmployeeRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1743,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateEmployeeResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1806,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const EmployeeData = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_hrm_v1alpha1_employee_service.ml",
      1874,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.hrm.v1alpha1.GetEmployeeRequest";
}

function make(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          id: id,
          expand: expand
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.GetEmployeeRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$1(id, expand) {
  return {
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.GetEmployeeRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEmployeeRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.payroll.hrm.v1alpha1.GetEmployeeResponse";
}

function make$1(employee, param) {
  return {
          employee: employee
        };
}

const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;

const merge_employee = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          employee: Curry._2(merge_employee, t1.employee, t2.employee)
        };
}

function spec$1(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employee",
                    "employee"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.employee);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(employee) {
  return {
          employee: employee
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.GetEmployeeResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employee);
  };
}

function constructor$3(employee) {
  return {
          employee: employee
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.GetEmployeeResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetEmployeeResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.payroll.hrm.v1alpha1.ListEmployeesRequest";
}

function make$2(grid, param) {
  return {
          grid: grid
        };
}

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "grid",
                    "grid"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(grid) {
  return {
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.ListEmployeesRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.grid);
  };
}

function constructor$5(grid) {
  return {
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.ListEmployeesRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEmployeesRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.payroll.hrm.v1alpha1.ListEmployeesResponse";
}

function make$3(employeesOpt, param) {
  const employees = employeesOpt !== undefined ? employeesOpt : /* [] */0;
  return {
          employees: employees
        };
}

const $$let$2 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;

const merge_employees = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "employees",
            "employees"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          employees: Curry._2(merge_employees, t1.employees, t2.employees)
        };
}

function spec$3(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "employees",
                    "employees"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.employees);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(employees) {
  return {
          employees: employees
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.ListEmployeesResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employees);
  };
}

function constructor$7(employees) {
  return {
          employees: employees
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.ListEmployeesResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListEmployeesResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.payroll.hrm.v1alpha1.CreateEmployeeRequest";
}

function make$4(employee, param) {
  return {
          employee: employee
        };
}

const merge_employee$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: EmployeeData.name,
                make: EmployeeData.make,
                from_proto: EmployeeData.from_proto,
                from_proto_exn: EmployeeData.from_proto_exn,
                to_proto: EmployeeData.to_proto,
                to_proto$p: EmployeeData.to_proto$p,
                merge: EmployeeData.merge,
                to_json: EmployeeData.to_json,
                from_json_exn: EmployeeData.from_json_exn,
                from_json: EmployeeData.from_json
              })
        ]));

function merge$4(t1, t2) {
  return {
          employee: Curry._2(merge_employee$1, t1.employee, t2.employee)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employee",
                    "employee"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: EmployeeData.name,
                        make: EmployeeData.make,
                        from_proto: EmployeeData.from_proto,
                        from_proto_exn: EmployeeData.from_proto_exn,
                        to_proto: EmployeeData.to_proto,
                        to_proto$p: EmployeeData.to_proto$p,
                        merge: EmployeeData.merge,
                        to_json: EmployeeData.to_json,
                        from_json_exn: EmployeeData.from_json_exn,
                        from_json: EmployeeData.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.employee);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(employee) {
  return {
          employee: employee
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.CreateEmployeeRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employee);
  };
}

function constructor$9(employee) {
  return {
          employee: employee
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.CreateEmployeeRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateEmployeeRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.payroll.hrm.v1alpha1.CreateEmployeeResponse";
}

function make$5(employee, param) {
  return {
          employee: employee
        };
}

const $$let$3 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;

const merge_employee$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          employee: Curry._2(merge_employee$2, t1.employee, t2.employee)
        };
}

function spec$5(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employee",
                    "employee"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.employee);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(employee) {
  return {
          employee: employee
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.CreateEmployeeResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employee);
  };
}

function constructor$11(employee) {
  return {
          employee: employee
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.CreateEmployeeResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateEmployeeResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.payroll.hrm.v1alpha1.UpdateEmployeeRequest";
}

function make$6(idOpt, employee, param) {
  const id = idOpt !== undefined ? idOpt : "";
  return {
          id: id,
          employee: employee
        };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_employee$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: EmployeeData.name,
                make: EmployeeData.make,
                from_proto: EmployeeData.from_proto,
                from_proto_exn: EmployeeData.from_proto_exn,
                to_proto: EmployeeData.to_proto,
                to_proto$p: EmployeeData.to_proto$p,
                merge: EmployeeData.merge,
                to_json: EmployeeData.to_json,
                from_json_exn: EmployeeData.from_json_exn,
                from_json: EmployeeData.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          id: Curry._2(merge_id$1, t1.id, t2.id),
          employee: Curry._2(merge_employee$3, t1.employee, t2.employee)
        };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "employee",
                        "employee"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: EmployeeData.name,
                            make: EmployeeData.make,
                            from_proto: EmployeeData.from_proto,
                            from_proto_exn: EmployeeData.from_proto_exn,
                            to_proto: EmployeeData.to_proto,
                            to_proto$p: EmployeeData.to_proto$p,
                            merge: EmployeeData.merge,
                            to_json: EmployeeData.to_json,
                            from_json_exn: EmployeeData.from_json_exn,
                            from_json: EmployeeData.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.id, param.employee);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(id, employee) {
  return {
          id: id,
          employee: employee
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.UpdateEmployeeRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.employee);
  };
}

function constructor$13(id, employee) {
  return {
          id: id,
          employee: employee
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.UpdateEmployeeRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmployeeRequest, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.payroll.hrm.v1alpha1.UpdateEmployeeResponse";
}

function make$7(employee, param) {
  return {
          employee: employee
        };
}

const $$let$4 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;

const merge_employee$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employee",
            "employee"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          employee: Curry._2(merge_employee$4, t1.employee, t2.employee)
        };
}

function spec$7(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employee.Buhta.Payroll.Hrm.V1alpha1.Employee;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employee",
                    "employee"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.employee);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(employee) {
  return {
          employee: employee
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.UpdateEmployeeResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employee);
  };
}

function constructor$15(employee) {
  return {
          employee: employee
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.UpdateEmployeeResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmployeeResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.payroll.hrm.v1alpha1.EmployeeData";
}

function make$8(tinOpt, family_nameOpt, given_nameOpt, patronymic_nameOpt, birthday_date, address, email, phoneOpt, employment, param) {
  const tin = tinOpt !== undefined ? tinOpt : "";
  const family_name = family_nameOpt !== undefined ? family_nameOpt : "";
  const given_name = given_nameOpt !== undefined ? given_nameOpt : "";
  const patronymic_name = patronymic_nameOpt !== undefined ? patronymic_nameOpt : "";
  const phone = phoneOpt !== undefined ? phoneOpt : "";
  return {
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment
        };
}

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "tin",
            "tin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_family_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "family_name",
            "familyName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_given_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "given_name",
            "givenName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_patronymic_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "patronymic_name",
            "patronymicName"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$5 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_birthday_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "birthday_date",
            "birthdayDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

const merge_address = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "address",
            "address"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_email = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "email",
            "email"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_phone = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "phone",
            "phone"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$6 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;

const merge_employment = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            20,
            "employment",
            "employment"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$6.name,
                make: $$let$6.make,
                from_proto: $$let$6.from_proto,
                from_proto_exn: $$let$6.from_proto_exn,
                to_proto: $$let$6.to_proto,
                to_proto$p: $$let$6.to_proto$p,
                merge: $$let$6.merge,
                to_json: $$let$6.to_json,
                from_json_exn: $$let$6.from_json_exn,
                from_json: $$let$6.from_json
              })
        ]));

function merge$8(t1, t2) {
  return {
          tin: Curry._2(merge_tin, t1.tin, t2.tin),
          family_name: Curry._2(merge_family_name, t1.family_name, t2.family_name),
          given_name: Curry._2(merge_given_name, t1.given_name, t2.given_name),
          patronymic_name: Curry._2(merge_patronymic_name, t1.patronymic_name, t2.patronymic_name),
          birthday_date: Curry._2(merge_birthday_date, t1.birthday_date, t2.birthday_date),
          address: Curry._2(merge_address, t1.address, t2.address),
          email: Curry._2(merge_email, t1.email, t2.email),
          phone: Curry._2(merge_phone, t1.phone, t2.phone),
          employment: Curry._2(merge_employment, t1.employment, t2.employment)
        };
}

function spec$8(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$1 = Buhta_payrollapis__Buhta_payroll_hrm_v1alpha1_employment_event_data.Buhta.Payroll.Hrm.V1alpha1.EmploymentEventData;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    2,
                    "tin",
                    "tin"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        3,
                        "family_name",
                        "familyName"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            4,
                            "given_name",
                            "givenName"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                5,
                                "patronymic_name",
                                "patronymicName"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    6,
                                    "birthday_date",
                                    "birthdayDate"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: $$let.name,
                                        make: $$let.make,
                                        from_proto: $$let.from_proto,
                                        from_proto_exn: $$let.from_proto_exn,
                                        to_proto: $$let.to_proto,
                                        to_proto$p: $$let.to_proto$p,
                                        merge: $$let.merge,
                                        to_json: $$let.to_json,
                                        from_json_exn: $$let.from_json_exn,
                                        from_json: $$let.from_json
                                      })
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        7,
                                        "address",
                                        "address"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            8,
                                            "email",
                                            "email"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                9,
                                                "phone",
                                                "phone"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string,
                                              ""
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                  [
                                                    20,
                                                    "employment",
                                                    "employment"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.message({
                                                        name: $$let$1.name,
                                                        make: $$let$1.make,
                                                        from_proto: $$let$1.from_proto,
                                                        from_proto_exn: $$let$1.from_proto_exn,
                                                        to_proto: $$let$1.to_proto,
                                                        to_proto$p: $$let$1.to_proto$p,
                                                        merge: $$let$1.merge,
                                                        to_json: $$let$1.to_json,
                                                        from_json_exn: $$let$1.from_json_exn,
                                                        from_json: $$let$1.from_json
                                                      })
                                                ]), Ocaml_protoc_plugin__Spec.nil)))))))));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry.app(serialize$8, [
        writer,
        param.tin,
        param.family_name,
        param.given_name,
        param.patronymic_name,
        param.birthday_date,
        param.address,
        param.email,
        param.phone,
        param.employment
      ]);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(tin, family_name, given_name, patronymic_name, birthday_date, address, email, phone, employment) {
  return {
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.hrm.v1alpha1.EmployeeData", spec$8(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.tin,
                param.family_name,
                param.given_name,
                param.patronymic_name,
                param.birthday_date,
                param.address,
                param.email,
                param.phone,
                param.employment
              ]);
  };
}

function constructor$17(tin, family_name, given_name, patronymic_name, birthday_date, address, email, phone, employment) {
  return {
          tin: tin,
          family_name: family_name,
          given_name: given_name,
          patronymic_name: patronymic_name,
          birthday_date: birthday_date,
          address: address,
          email: email,
          phone: phone,
          employment: employment
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.hrm.v1alpha1.EmployeeData", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EmployeeData, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

const getEmployee_0 = {
  name: GetEmployeeRequest.name,
  make: GetEmployeeRequest.make,
  from_proto: GetEmployeeRequest.from_proto,
  from_proto_exn: GetEmployeeRequest.from_proto_exn,
  to_proto: GetEmployeeRequest.to_proto,
  to_proto$p: GetEmployeeRequest.to_proto$p,
  merge: GetEmployeeRequest.merge,
  to_json: GetEmployeeRequest.to_json,
  from_json_exn: GetEmployeeRequest.from_json_exn,
  from_json: GetEmployeeRequest.from_json
};

const getEmployee_1 = {
  name: GetEmployeeResponse.name,
  make: GetEmployeeResponse.make,
  from_proto: GetEmployeeResponse.from_proto,
  from_proto_exn: GetEmployeeResponse.from_proto_exn,
  to_proto: GetEmployeeResponse.to_proto,
  to_proto$p: GetEmployeeResponse.to_proto$p,
  merge: GetEmployeeResponse.merge,
  to_json: GetEmployeeResponse.to_json,
  from_json_exn: GetEmployeeResponse.from_json_exn,
  from_json: GetEmployeeResponse.from_json
};

const getEmployee = [
  getEmployee_0,
  getEmployee_1
];

const listEmployees_0 = {
  name: ListEmployeesRequest.name,
  make: ListEmployeesRequest.make,
  from_proto: ListEmployeesRequest.from_proto,
  from_proto_exn: ListEmployeesRequest.from_proto_exn,
  to_proto: ListEmployeesRequest.to_proto,
  to_proto$p: ListEmployeesRequest.to_proto$p,
  merge: ListEmployeesRequest.merge,
  to_json: ListEmployeesRequest.to_json,
  from_json_exn: ListEmployeesRequest.from_json_exn,
  from_json: ListEmployeesRequest.from_json
};

const listEmployees_1 = {
  name: ListEmployeesResponse.name,
  make: ListEmployeesResponse.make,
  from_proto: ListEmployeesResponse.from_proto,
  from_proto_exn: ListEmployeesResponse.from_proto_exn,
  to_proto: ListEmployeesResponse.to_proto,
  to_proto$p: ListEmployeesResponse.to_proto$p,
  merge: ListEmployeesResponse.merge,
  to_json: ListEmployeesResponse.to_json,
  from_json_exn: ListEmployeesResponse.from_json_exn,
  from_json: ListEmployeesResponse.from_json
};

const listEmployees = [
  listEmployees_0,
  listEmployees_1
];

const createEmployee_0 = {
  name: CreateEmployeeRequest.name,
  make: CreateEmployeeRequest.make,
  from_proto: CreateEmployeeRequest.from_proto,
  from_proto_exn: CreateEmployeeRequest.from_proto_exn,
  to_proto: CreateEmployeeRequest.to_proto,
  to_proto$p: CreateEmployeeRequest.to_proto$p,
  merge: CreateEmployeeRequest.merge,
  to_json: CreateEmployeeRequest.to_json,
  from_json_exn: CreateEmployeeRequest.from_json_exn,
  from_json: CreateEmployeeRequest.from_json
};

const createEmployee_1 = {
  name: CreateEmployeeResponse.name,
  make: CreateEmployeeResponse.make,
  from_proto: CreateEmployeeResponse.from_proto,
  from_proto_exn: CreateEmployeeResponse.from_proto_exn,
  to_proto: CreateEmployeeResponse.to_proto,
  to_proto$p: CreateEmployeeResponse.to_proto$p,
  merge: CreateEmployeeResponse.merge,
  to_json: CreateEmployeeResponse.to_json,
  from_json_exn: CreateEmployeeResponse.from_json_exn,
  from_json: CreateEmployeeResponse.from_json
};

const createEmployee = [
  createEmployee_0,
  createEmployee_1
];

const updateEmployee_0 = {
  name: UpdateEmployeeRequest.name,
  make: UpdateEmployeeRequest.make,
  from_proto: UpdateEmployeeRequest.from_proto,
  from_proto_exn: UpdateEmployeeRequest.from_proto_exn,
  to_proto: UpdateEmployeeRequest.to_proto,
  to_proto$p: UpdateEmployeeRequest.to_proto$p,
  merge: UpdateEmployeeRequest.merge,
  to_json: UpdateEmployeeRequest.to_json,
  from_json_exn: UpdateEmployeeRequest.from_json_exn,
  from_json: UpdateEmployeeRequest.from_json
};

const updateEmployee_1 = {
  name: UpdateEmployeeResponse.name,
  make: UpdateEmployeeResponse.make,
  from_proto: UpdateEmployeeResponse.from_proto,
  from_proto_exn: UpdateEmployeeResponse.from_proto_exn,
  to_proto: UpdateEmployeeResponse.to_proto,
  to_proto$p: UpdateEmployeeResponse.to_proto$p,
  merge: UpdateEmployeeResponse.merge,
  to_json: UpdateEmployeeResponse.to_json,
  from_json_exn: UpdateEmployeeResponse.from_json_exn,
  from_json: UpdateEmployeeResponse.from_json
};

const updateEmployee = [
  updateEmployee_0,
  updateEmployee_1
];

const V1alpha1_EmployeeService = {
  GetEmployee: {
    name: "/buhta.payroll.hrm.v1alpha1.EmployeeService/GetEmployee",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmployeeService",
    method_name: "GetEmployee",
    $$Request: {
      name: GetEmployeeRequest.name,
      make: GetEmployeeRequest.make,
      from_proto: GetEmployeeRequest.from_proto,
      from_proto_exn: GetEmployeeRequest.from_proto_exn,
      to_proto: GetEmployeeRequest.to_proto,
      to_proto$p: GetEmployeeRequest.to_proto$p,
      merge: GetEmployeeRequest.merge,
      to_json: GetEmployeeRequest.to_json,
      from_json_exn: GetEmployeeRequest.from_json_exn,
      from_json: GetEmployeeRequest.from_json
    },
    $$Response: {
      name: GetEmployeeResponse.name,
      make: GetEmployeeResponse.make,
      from_proto: GetEmployeeResponse.from_proto,
      from_proto_exn: GetEmployeeResponse.from_proto_exn,
      to_proto: GetEmployeeResponse.to_proto,
      to_proto$p: GetEmployeeResponse.to_proto$p,
      merge: GetEmployeeResponse.merge,
      to_json: GetEmployeeResponse.to_json,
      from_json_exn: GetEmployeeResponse.from_json_exn,
      from_json: GetEmployeeResponse.from_json
    }
  },
  getEmployee: getEmployee,
  ListEmployees: {
    name: "/buhta.payroll.hrm.v1alpha1.EmployeeService/ListEmployees",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmployeeService",
    method_name: "ListEmployees",
    $$Request: {
      name: ListEmployeesRequest.name,
      make: ListEmployeesRequest.make,
      from_proto: ListEmployeesRequest.from_proto,
      from_proto_exn: ListEmployeesRequest.from_proto_exn,
      to_proto: ListEmployeesRequest.to_proto,
      to_proto$p: ListEmployeesRequest.to_proto$p,
      merge: ListEmployeesRequest.merge,
      to_json: ListEmployeesRequest.to_json,
      from_json_exn: ListEmployeesRequest.from_json_exn,
      from_json: ListEmployeesRequest.from_json
    },
    $$Response: {
      name: ListEmployeesResponse.name,
      make: ListEmployeesResponse.make,
      from_proto: ListEmployeesResponse.from_proto,
      from_proto_exn: ListEmployeesResponse.from_proto_exn,
      to_proto: ListEmployeesResponse.to_proto,
      to_proto$p: ListEmployeesResponse.to_proto$p,
      merge: ListEmployeesResponse.merge,
      to_json: ListEmployeesResponse.to_json,
      from_json_exn: ListEmployeesResponse.from_json_exn,
      from_json: ListEmployeesResponse.from_json
    }
  },
  listEmployees: listEmployees,
  CreateEmployee: {
    name: "/buhta.payroll.hrm.v1alpha1.EmployeeService/CreateEmployee",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmployeeService",
    method_name: "CreateEmployee",
    $$Request: {
      name: CreateEmployeeRequest.name,
      make: CreateEmployeeRequest.make,
      from_proto: CreateEmployeeRequest.from_proto,
      from_proto_exn: CreateEmployeeRequest.from_proto_exn,
      to_proto: CreateEmployeeRequest.to_proto,
      to_proto$p: CreateEmployeeRequest.to_proto$p,
      merge: CreateEmployeeRequest.merge,
      to_json: CreateEmployeeRequest.to_json,
      from_json_exn: CreateEmployeeRequest.from_json_exn,
      from_json: CreateEmployeeRequest.from_json
    },
    $$Response: {
      name: CreateEmployeeResponse.name,
      make: CreateEmployeeResponse.make,
      from_proto: CreateEmployeeResponse.from_proto,
      from_proto_exn: CreateEmployeeResponse.from_proto_exn,
      to_proto: CreateEmployeeResponse.to_proto,
      to_proto$p: CreateEmployeeResponse.to_proto$p,
      merge: CreateEmployeeResponse.merge,
      to_json: CreateEmployeeResponse.to_json,
      from_json_exn: CreateEmployeeResponse.from_json_exn,
      from_json: CreateEmployeeResponse.from_json
    }
  },
  createEmployee: createEmployee,
  UpdateEmployee: {
    name: "/buhta.payroll.hrm.v1alpha1.EmployeeService/UpdateEmployee",
    package_name: "buhta.payroll.hrm.v1alpha1",
    service_name: "EmployeeService",
    method_name: "UpdateEmployee",
    $$Request: {
      name: UpdateEmployeeRequest.name,
      make: UpdateEmployeeRequest.make,
      from_proto: UpdateEmployeeRequest.from_proto,
      from_proto_exn: UpdateEmployeeRequest.from_proto_exn,
      to_proto: UpdateEmployeeRequest.to_proto,
      to_proto$p: UpdateEmployeeRequest.to_proto$p,
      merge: UpdateEmployeeRequest.merge,
      to_json: UpdateEmployeeRequest.to_json,
      from_json_exn: UpdateEmployeeRequest.from_json_exn,
      from_json: UpdateEmployeeRequest.from_json
    },
    $$Response: {
      name: UpdateEmployeeResponse.name,
      make: UpdateEmployeeResponse.make,
      from_proto: UpdateEmployeeResponse.from_proto,
      from_proto_exn: UpdateEmployeeResponse.from_proto_exn,
      to_proto: UpdateEmployeeResponse.to_proto,
      to_proto$p: UpdateEmployeeResponse.to_proto$p,
      merge: UpdateEmployeeResponse.merge,
      to_json: UpdateEmployeeResponse.to_json,
      from_json_exn: UpdateEmployeeResponse.from_json_exn,
      from_json: UpdateEmployeeResponse.from_json
    }
  },
  updateEmployee: updateEmployee
};

const V1alpha1 = {
  GetEmployeeRequest: GetEmployeeRequest,
  GetEmployeeResponse: GetEmployeeResponse,
  ListEmployeesRequest: ListEmployeesRequest,
  ListEmployeesResponse: ListEmployeesResponse,
  CreateEmployeeRequest: CreateEmployeeRequest,
  CreateEmployeeResponse: CreateEmployeeResponse,
  UpdateEmployeeRequest: UpdateEmployeeRequest,
  UpdateEmployeeResponse: UpdateEmployeeResponse,
  EmployeeData: EmployeeData,
  EmployeeService: V1alpha1_EmployeeService
};

const Hrm = {
  V1alpha1: V1alpha1
};

const Payroll = {
  Hrm: Hrm
};

const Buhta = {
  Payroll: Payroll
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetEmployeeRequest Not a pure module */
